export default "__VITE_ASSET__DX8u6RoS__"